import {
  PDFActivityPlanInfoItem,
  PDFActivityPlanInfoWrapper,
  PDFDocumentLetterhead,
  PDFProgression
} from 'components/PDFDocuments/PDFDocument';
import React from 'react';
import { ActivityPlan, Progression } from 'types/activityPlan';
import { DraftActivityPlan, DraftProgression } from 'types/draftActivityPlan';
import { ProgressionTypes } from 'utils/activityPlan';
import { extractProgramInfoFromUri } from 'utils/extractProgramInfoFromUri';

interface Props {
  activityPlan: ActivityPlan | DraftActivityPlan | undefined;
  userId: string;
}

export const ChronicUserPDFDocument = ({
  activityPlan,
  userId
}: Props): JSX.Element | null => {
  if (!activityPlan) {
    return null;
  }

  const { uri, progressions } = activityPlan;
  const { program, indication, stream } = extractProgramInfoFromUri(uri);
  const pdfProgressions: JSX.Element[] = [];
  progressions.forEach((progression: Progression | DraftProgression) => {
    pdfProgressions.push(
      <PDFProgression
        progression={progression}
        type={ProgressionTypes[program]}
        key={progression.uuid}
      />
    );
  });

  return (
    <PDFDocumentLetterhead title="Exercise Therapy Plan">
      <PDFActivityPlanInfoWrapper>
        <PDFActivityPlanInfoItem text={`User ID: ${userId}`} />
        <PDFActivityPlanInfoItem text={`Program: ${program}`} />
        <PDFActivityPlanInfoItem text={`Indication: ${indication}`} />
        <PDFActivityPlanInfoItem text={`Activity Stream: ${stream}`} />
      </PDFActivityPlanInfoWrapper>
      {pdfProgressions}
    </PDFDocumentLetterhead>
  );
};
